export class BiMap<TKey extends number | string, TValue> {
	value: [key: TKey, value: TValue][] = [];

	constructor(object?: { [key in TKey]: TValue }) {
		this.value = object ? (Object.entries(object) as [key: TKey, value: TValue][]) : [];
	}

	get size() {
		return this.value.length;
	}

	set(key: TKey | unknown, value: TValue) {
		this.value.push([key as TKey, value]);
	}
	get(key: TKey | unknown) {
		return this.value.find(([k]) => k === key)?.[1];
	}
	getKey(value: TValue) {
		return this.value.find(([, v]) => v === value)?.[0];
	}
	getKeyByI18n(value: string) {
		return this.value.find(([, v]) => typeof v === 'function' && v() === value)?.[0];
	}
	clear() {
		this.value = [];
	}
	delete(key: TKey | unknown) {
		this.value = this.value.filter(([k]) => k !== key);
	}
	deleteValue(value: TValue) {
		this.value = this.value.filter(([, v]) => v !== value);
	}
	entries() {
		return this.value;
	}
	has(key: TKey | unknown) {
		return this.value.some(([k]) => k === key);
	}
	hasValue(value: TValue) {
		return this.value.some(([, v]) => v === value);
	}
	keys() {
		return this.value.map(([k]) => k);
	}
	values() {
		return this.value.map(([, v]) => (typeof v === 'function' ? v() : v));
	}
}
